// extracted by mini-css-extract-plugin
module.exports = {"crossIcon":"MappingTable_crossIcon__2TL9B","arrowIcon":"MappingTable_arrowIcon__3OCyQ","tableHeaderCell":"MappingTable_tableHeaderCell__1d-w-","table":"MappingTable_table__gVmlR"};